import * as React from "react";
import { TableFieldDataItem } from "../../table-field.types";
import { DatasheetFieldComponentOriginFieldGetDto } from "@common/dto/datasheet/field-component/origin-field-dto";

export type TableFieldColumn = {
  field: DatasheetFieldComponentOriginFieldGetDto;
  width: number;
};

export type RowProps = {
  selected: boolean;
  columns: Array<TableFieldColumn>;
  data: TableFieldDataItem;
  onClick: (data: TableFieldDataItem) => void;
  editable: boolean;
  onCellChange: (rowRrn: number, column: DatasheetFieldComponentOriginFieldGetDto, value: any) => void;
  tableContentStyle?: React.CSSProperties;
};

export const useController = (props: RowProps) => {
  const { onClick, data } = props;

  const handleClick = React.useCallback(() => {
    onClick(data);
  }, [data, onClick]);

  return {
    handleClick,
  };
}